import { render, staticRenderFns } from "./SunpodStationIndex.vue?vue&type=template&id=35abd0f0"
import script from "./SunpodStationIndex.vue?vue&type=script&lang=js"
export * from "./SunpodStationIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports